import PeruFlag from "../assets/img/tt_flag_pe-2.png";
import UsaFlag from "../assets/img/tt_flag_us-3.png";
import FranceFlag from "../assets/img/tt_flag_fr-2.png";

function Empresa() {
    return (
        <section className="empresa" id="empresa">
            <div className="wrap">

                {/* ESCRITORIO: diseño imagen 3 (empresa + idiomas grandes + valores) */}
                <div className="emp3">
                    <div className="emp3-left">
                        <div className="eyebrow">Nuestra empresa</div>

                        <p style={{ textAlign: "justify", textJustify: "inter-word" }}>
                            Tradutec Perú es una empresa que se fundó en el año 2016, con sede en Lima, Perú. Contamos con más de 10 años de experiencia.
                        </p>

                        <p style={{ textAlign: "justify", textJustify: "inter-word" }}>
                            Nuestra misión es conectar empresas y profesionales con el mundo a través de soluciones lingüísticas especializadas, ofreciendo traducciones precisas, confiables y de alta calidad que faciliten una comunicación global efectiva.
                        </p>

                        <p style={{ textAlign: "justify", textJustify: "inter-word" }}>
                            Nuestro equipo está conformado por profesionales expertos en traducción e interpretación que, gracias a su trayectoria y participación en proyectos multinacionales, cuenta con amplia experiencia y dominio terminológico.
                        </p>
                    </div>

                    <div className="emp3-right">
                        <div className="emp3-idiomas">
                            <h3 className="emp3-h">Idiomas con los que trabajamos</h3>

                            <div className="emp3-flags">
                                <div className="emp3-flag">
                                    <img src={PeruFlag} alt="Español" />
                                    <span>Español</span>
                                </div>

                                <div className="emp3-flag">
                                    <img src={UsaFlag} alt="Inglés" />
                                    <span>Inglés</span>
                                </div>

                                <div className="emp3-flag">
                                    <img src={FranceFlag} alt="Francés" />
                                    <span>Francés</span>
                                </div>
                            </div>
                        </div>

                        <div className="emp3-divider"></div>

                        <div className="emp3-valores">
                            <h3 className="emp3-h">Nuestros valores</h3>
                            <ul className="emp3-vlist">
                                <li><i className="fas fa-bullseye"></i> Precisión</li>
                                <li><i className="fas fa-shield-halved"></i> Confidencialidad garantizada</li>
                                <li><i className="far fa-clock"></i> Puntualidad y cumplimiento con los plazos de entrega</li>
                                <li><i className="fas fa-user-tie"></i> Profesionalismo</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* MÓVIL: tarjetas actuales del mockup */}
                <div className="emp-grid">
                    <div className="emp-card">
                        <div className="eyebrow">Nuestra empresa</div>
                        <div className="emp-row">
                            <div className="emp-ic">
                                <i className="fas fa-building"></i>
                            </div>

                            <div className="emp-body">
                                <p>
                                    Tradutec Perú es una empresa fundada en el año 2016 en Lima, Perú, especializada en servicios de traducción e interpretación profesional.
                                </p>
                                <p>
                                    Contamos con amplia experiencia trabajando con empresas, profesionales y proyectos multinacionales.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="idiomas-card">
                        <h3>Idiomas</h3>
                        <ul className="idioma-list">
                            <li>
                                <img src={PeruFlag} alt="Español" />
                                <span>Español</span>
                            </li>
                            <li>
                                <img src={UsaFlag} alt="Inglés" />
                                <span>Inglés</span>
                            </li>
                            <li>
                                <img src={FranceFlag} alt="Francés" />
                                <span>Francés</span>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Empresa;